import React from 'react';
import styled from 'styled-components';

import appConfig from '../../../../appConfig';
import USstateConfig from '../../../constants/USstateConfig';

const state = appConfig.regions.usState;

export const PlayupExclusionDescription = () => {
	switch (state) {
		case 'IA':
			return (
				<>
					<DescriptionText>
						PlayUp is committed to ensuring its customers participate in sports betting in a way that is both
						entertaining and fun. PlayUp wants all its patrons to enjoy real-money gambling as a planned and budgeted
						entertainment option.
					</DescriptionText>
					<DescriptionText>
						To help curtail disordered and problem gambling in the state of Iowa, PlayUp created its own self-exclusion
						program to offer individuals the ability to ban themselves from PlayUp in Iowa for one year, five years or
						their lifetime. Please review and acknowledge via check boxes before self-excluding from PlayUp in Iowa.
					</DescriptionText>
				</>
			);
		case 'OH':
			return (
				<DescriptionText>
					PlayUp is committed to helping you enjoy our products responsibly. You have the ability to self-exclude in
					multiple ways.
				</DescriptionText>
			);
	}

	return <DescriptionText>[missing description]</DescriptionText>;
};

export const StateExclusionDescription = () => {
	switch (state) {
		case 'IA':
			return (
				<>
					<DescriptionText>
						For patrons who wish to self-exclude from all forms of gaming in Iowa, the exclusion process must be done by
						completing the IRGC’s enrollment form and submitting it in one of the following ways: either by email by
						mail, or by enrolling in person at the IRGC Des Moines office, an Iowa Gambling Treatment Program (IGTP)
						agency, or any state licensed gambling facility.
					</DescriptionText>
					<DescriptionText>
						Enrollment in the program begins on the date next to the signature on the enrollment form, unless otherwise
						specified by the IRGC. The state of Iowa’s self-exclusion program is available for a period of five years or
						life. For more information on the enrollment form and the program{' '}
						<a href="https://irgc.iowa.gov/self-exclusion-program" target="_blank" rel="noreferrer">
							click here
						</a>
						.
					</DescriptionText>
					<SectionTitle>Additional Resources</SectionTitle>
					<DescriptionText>
						Gambling disorder or gambling addiction is considered a diagnosable and treatable disorder. The following
						list provides information regarding community, public, and private treatment services, peer support groups,
						and other programs designed to prevent, treat, or monitor individuals with a gambling problem and provide
						support to family members.
					</DescriptionText>
					<DescriptionText>
						State of Iowa Department of Health and Human Services -{' '}
						<a href="https://hhs.iowa.gov/igtp" target="_blank" rel="noreferrer">
							https://hhs.iowa.gov/igtp
						</a>
						<br />
						Iowa Gambling Treatment Program - <a href={`tel:${USstateConfig.gamblingPhone}`}>{USstateConfig.gamblingPhone}</a>
						<a href="https://yourlifeiowa.org/gambling" target="_blank" rel="noreferrer">
							https://yourlifeiowa.org/gambling
						</a>
						<br />
						National Gambling Helpline - <a href="tel:18005224700">1-800-522-4700</a>
						<br />
						National Council on Problem Gambling -{' '}
						<a href="https://www.ncpgambling.org/" target="_blank" rel="noreferrer">
							https://www.ncpgambling.org/
						</a>
						<br />
						Gamblers Anonymous -{' '}
						<a href="https://www.gamblersanonymous.org/ga/" target="_blank" rel="noreferrer">
							https://www.gamblersanonymous.org/ga/
						</a>
					</DescriptionText>
				</>
			);
		case 'OH':
			return (
				<>
					<DescriptionText>
						To help curtail disordered and problem gambling in the state, the Ohio Casino Control Commission created the
						Ohio voluntary exclusion program (VEP) to offer individuals the ability to ban themselves from a casino or
						racino facility or their online sports wagering account for one year, five years or their lifetime.
					</DescriptionText>
					<DescriptionText>
						To enroll or remove yourself from the VEP, you can do so in person at the Commissions offices located at
						each casino property or the Main Office in downtown Columbus
					</DescriptionText>
					<DescriptionText>
						Remote options are also available - please call <a href="tel:614-387-5854">614-387-5854</a> for more
						information or visit the Help for Problem Gamblers pace to request a self-exclusion.
					</DescriptionText>
					<a
						href="https://casinocontrol.ohio.gov/ResponsibleGambling/VoluntaryExclusionProgram.aspx"
						target="_blank"
						rel="noreferrer"
					>
						Voluntary Exclusion Program
					</a>
				</>
			);
	}
	return <DescriptionText>[missing description]</DescriptionText>;
};

const DescriptionText = styled.p`
	margin-bottom: 1rem;

	a {
		text-decoration: underline;
	}
`;

const SectionTitle = styled.h4`
	margin-bottom: 1rem;
	font-weight: 800;
`;
